export const getImage = (image) =>
  image && image.length
    ? image[0]?.formats?.small?.url ||
      image[0]?.formats?.thumbnail?.url ||
      image[0]?.url
    : '/img/no-image.png';

export const getLogo = (user) =>
  user.logo?.formats?.thumbnail?.url || user.logo?.url;
